import React from 'react';
import classNames from 'classnames';

const StatusList = (props) => {
  return props.list.map((statusItem, index) => {
    return (
      <li
        className={classNames({
          'c-service-info__list__item': true,
          'c-service-info__list__item--is-error': statusItem.StatusLevel === 2,
          'c-service-info__list__item--is-warning':
            statusItem.StatusLevel === 1,
        })}
        key={index}
      >
        {statusItem.Name}
        <span className="show-for-sr">{statusItem.StatusName}</span>
      </li>
    );
  });
};

export default StatusList;
